import styled from 'styled-components';

import { COLORS, DELTA_PILL } from '../../theme/tokens';
import { Text } from '../Text/Text';

export type DeltaSentiment = keyof typeof DELTA_PILL;

export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
`;

/** Figma trend_indicator: a 6px-radius pill tinted to the delta sentiment. */
export const Pill = styled.span<{ $sentiment: DeltaSentiment }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  border-radius: 6px;
  background: ${(p) => DELTA_PILL[p.$sentiment].bg};
  color: ${(p) => DELTA_PILL[p.$sentiment].fg};
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
`;

export const Vs = styled(Text)`
  color: ${COLORS.text};
  letter-spacing: -0.0762px;
`;
